import { SubscriptionTag } from '@models/membership/SubscriptionTag'
import { SBAPI } from '@supplement-bacon/react-toolkit/utils'
import { TableParams } from '@supplement-bacon/sb-table-filters'
import { MEMBERSHIP_SUBSCRIPTION_TAGS_URL } from '@utils/urls'

const fetchSubscriptionTags = (params: TableParams) =>
  SBAPI.FetchPaginated<SubscriptionTag[]>(
    MEMBERSHIP_SUBSCRIPTION_TAGS_URL,
    params
  )

const fetchSubscriptionTagById = (id: number, params?: TableParams) =>
  SBAPI.Fetch<SubscriptionTag>(
    `${MEMBERSHIP_SUBSCRIPTION_TAGS_URL}/${id}`,
    params
  )

const createSubscriptionTag = (tag: SubscriptionTag) =>
  SBAPI.Post(MEMBERSHIP_SUBSCRIPTION_TAGS_URL, tag)

const updateSubscriptionTag = (tag: SubscriptionTag) =>
  SBAPI.Put(`${MEMBERSHIP_SUBSCRIPTION_TAGS_URL}/${tag.id}`, tag)

const deleteSubscriptionTag = (tag: SubscriptionTag) =>
  SBAPI.Delete(`${MEMBERSHIP_SUBSCRIPTION_TAGS_URL}/${tag.id}`)

export {
  createSubscriptionTag,
  deleteSubscriptionTag,
  fetchSubscriptionTagById,
  fetchSubscriptionTags,
  updateSubscriptionTag,
}
